module.exports = __webpack_public_path__ + "static/media/gu.2a95d57a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gu.svg
// module id = 137
// module chunks = 0